module.exports = {
  path: 'information',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceSlaveInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/routes/show/routes/information/index.js